import apiClient from './apiClient';

const agreementService = {
  // Agreement Services
  getAllAgreements: async () => {
    const response = await apiClient.post('/agreement/GetAllAgreements');
    return response.data?.Data?.Items || [];
  },

  addAgreement: async (agreement) => {
    const response = await apiClient.post('/agreement/AddAgreement', agreement);
    return response.data;
  },

  deleteAgreement: async (id) => {
    const response = await apiClient.post('/agreement/DeleteAgreement', null, { params: { id } });
    return response.data;
  },

  // User Agreement Services
  getUserAgreements: async (userId) => {
    const response = await apiClient.post('/agreement/GetUserAgreements', null, { params: { id: userId } });
    return response.data?.Data?.Items || [];
  },

  addUserAgreement: async (userAgreement) => {
    const response = await apiClient.post('/agreement/AddUserAgreement', userAgreement);
    return response.data;
  },

  deleteUserAgreement: async (id) => {
    const response = await apiClient.post('/agreement/DeleteUserAgreement', null, { params: { id } });
    return response.data;
  }
};

export default agreementService;